import { render, staticRenderFns } from "./CommentActivator.vue?vue&type=template&id=a69c7e1e"
import script from "./CommentActivator.vue?vue&type=script&lang=ts"
export * from "./CommentActivator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports